<template>
    <div @mouseleave="isContainerActive = false" style= "position: relative">
      <div class="rulesetIcon"  v-if="!placeholdersEnabled" @click.stop="shareProps(blockId, emailData[blockId]); isContainerActive = true; currentDiv = childId">
        <span class="material-symbols-outlined">rule</span>
      </div>
      <div v-if="hasChildren">
        <div
          @mousemove="checkProximity($event, childId), currentDivHover = childId"
          @mouseleave="resetProximity"
          v-for="childId in data.props.childrenIds"
          :key="childId"
          class="component"
        >
        <component
             v-if="!placeholdersEnabled? childId == data.props.rules[data.props.previewIndex].conditionalBlock : conditionalResults.includes(childId)"
            :is="getComponentType(emailData[childId]?.type)"
            :data="emailData[childId]?.data"
            :emailData="emailData"
            :blockId=" childId"
            @click.stop="shareProps(childId, emailData[childId]); isContainerActive = true; currentDiv = childId"
            @dblclick.stop="shareProps(blockId, emailData[blockId]); isContainerActive = true; currentDiv = childId"
        ></component> 
          <div v-if="isContainerActive  && currentDiv == childId" class="delete-button" @click.stop="deleteBlock()">
            <span class="material-symbols-outlined">delete</span>
          </div>
      </div>
      </div>
      <div class="elseBlock" v-if="!hasChildren">Ruleset Blocks are special, conditionally rendered blocks</div>
    </div>
</template>
  
  <script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import EmptyBlock from './EmptyBlock.vue';
  import HtmlBlock from './HtmlBlock.vue';
  import HeadingBlock from './HeadingBlock.vue';
  import TextBlock from './TextBlock.vue';
  import SpacerBlock from './SpacerBlock.vue';
  import ImageBlock from './ImageBlock.vue';
  import ButtonBlock from './ButtonBlock.vue';
  import DividerBlock from './DividerBlock.vue';
  import ColumnsContainerBlock from './ColumnsContainerBlock.vue';
  import ContainerBlock from './ContainerBlock.vue';
  import RulesetBlock from './RulesetBlock.vue';
  import AddList from '../Reusables/AddList.vue';
  import {getXmlValueByPath} from '@/utils/getXmlValueByPath'

  export default {
    name: 'RulesetBlock',
    components: {
      EmptyBlock,
      AddList,
    },
    props: {
      data: Object,
      emailData: Object,
      blockId: String, //ID of the rendered container, props form Preview.vue
    },
    data() {
      return {
        showAddButton: false,
        showAddList: false,
        addListStyle: {},
        activeChildComponent: null, //stores Id of Child Component, where the AddList was triggered from
        isContainerActive: false,
        isNearTopButton: false,
        isNearBottomButton: false,
        clicked: 'container', //type of the clicked component
        position: 'bottom',
        currentDiv: '', //stores the clicked div ID
        currentDivHover: '', //stores the currently hovered div
        conditionalResults: []
      };
    },
    computed: {
      ...mapState(['xPathPlaceholders']),
      ...mapGetters(['getView', 'getPlaceholdersEnabled']),
      currentView() {
        return this.getView;
      },
      hasChildren() {
        return this.data?.props?.childrenIds?.length > 0;
      },
      placeholdersEnabled(){
        return this.getPlaceholdersEnabled
      }

    },
    methods: {
      ...mapActions(['updateSharedData', 'removeBlock', 'addNewBlock']),
      getStyle(style) {
        let border;
        const backgroundColor = style?.backgroundColor || null;
        if (style?.borderColor && style?.borderColor != null) {
          border = `${style?.borderColor} ${style?.borderWidth || 1 }px solid` || null;
        }
        const borderRadius = `${style?.borderRadius}px` || null;
        let width;
        if (style?.width == 'inherit') {
          width = 'inherit';
        } else {
          width = `${style?.width}px` || 'inherit';
        }
        let height;
        if (style?.height == 'auto') {
          height = 'auto';
        } else {
          height = `${style?.height}px` || 'auto';
        }
        const padding = `${0}px ${0}px ${0}px ${0}px`
          return {
            backgroundColor: backgroundColor,
            border: border,
            borderRadius: borderRadius,
            padding: padding,
            width: width,
            height: height
         /*  margin: margin */
        }
      },
      getComponentType(type) {
        const components = {
          Heading: HeadingBlock,
          HtmlBlock: HtmlBlock,
          Text: TextBlock,
          Spacer: SpacerBlock,
          Image: ImageBlock,
          Container: ContainerBlock,
          Button: ButtonBlock,
          Divider: DividerBlock,
          ColumnsContainer: ColumnsContainerBlock,
          Ruleset: RulesetBlock
        };
        return components[type] || 'div';
      },
      shareProps(childId, data) {
        console.log({childId, data})
        this.updateSharedData({id: childId, data});
      },
      async updateConditionalResults() {
        // Angenommen, du iterierst über alle childIds, die du prüfen möchtest
        for (const childId of this.data?.props?.childrenIds) {
          const rule = this.data.props.rules.find(r => r.conditionalBlock === childId);
          const statement = this.data.props?.rules[this.data.props.previewIndex].statement;
          const xPath = (statement) ? this.xPathPlaceholders.find(p => p.placeholder === statement)?.xpath : null;
          const value = rule.value;
          const operator = rule.operator;
          if (xPath && operator != 'else') {
            // Hier wird der komplette Ausdruck aufgebaut, z. B. "/document/... > 5"
            //const expression = rule.fullCondition ? rule.fullCondition : `${xPath}${operator}${value}`;
            const expression = `${xPath}${operator}${value}`;
            let result
            if (xPath && operator && value ) result = await getXmlValueByPath(expression);
            let finalResult
            if (result[0]) {
              finalResult = result[0]
            }else {
              finalResult = false
            }
            if (finalResult === '') finalResult = false;
            // Speichere das Ergebnis im Objekt
            if(finalResult == 'true') this.conditionalResults.push(childId)
          }
        if (this.conditionalResults == []){
          const elseBlock = this.data.props.rules.find(r => r.operator === 'else');
          if (elseBlock) this.conditionalResults.push(elseBlock.conditionalBlock);
        }
        }
      },
      renderBlock(childId){
        return this.conditionalResults[childId]
      },
      handleClickOutside(event) {
        const addListElement = this.$refs.addList?.$el;
        if (this.showAddList && addListElement && !addListElement.contains(event.target)) {
          this.closeAddList();
        }
      },
      closeAddList() {
        this.showAddList = false;
        this.activeButtonId = null;
        document.removeEventListener('click', this.handleClickOutside);
      },
      addBlockContainer(type) {
        this.addNewBlock({
          type: type,
          targetId: this.activeChildComponent,
          position: this.position,
          parentId: this.blockId,
          parentType: 'Container'
        });
        this.showAddList = false;
      },
      deleteBlock() {
        this.removeBlock({ parentId: 'root' , parentType: 'root', blockId: this.blockId });
      },
      checkProximity(event, childId) {
        const rect = event.currentTarget.getBoundingClientRect();
        const mouseY = event.clientY;
        const mouseX = event.clientX;
  
        // Check if the mouse is over any clickable elements within the container
        const elementUnderMouse = document.elementFromPoint(mouseX, mouseY);
        const isInteractiveElement = elementUnderMouse && ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(elementUnderMouse.tagName);
  
        if (!isInteractiveElement) {
          this.isNearTopButton = mouseY >= rect.top - 10 && mouseY <= rect.top + 10 && mouseX >= rect.left && mouseX <= rect.right;
          this.isNearBottomButton = mouseY >= rect.bottom - 10 && mouseY <= rect.bottom + 10 && mouseX >= rect.left && mouseX <= rect.right;
        } else {
          this.isNearTopButton = false;
          this.isNearBottomButton = false;
        }
      },
      resetProximity() {
        this.isNearTopButton = false;
        this.isNearBottomButton = false;
      },
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    mounted() {
      this.updateConditionalResults();
    }
    /* watch: {
      'data': {
        handler() {
          this.updateConditionalResults();
        },
        deep: true
      }
  }} */
  }
  </script>
  
  <style scoped>
  .component {
    position: relative;
  }
  .component:hover {
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(0, 0, 0, 0.02) 0px 0px 0px 1px; 
    /* border: 2px solid red; */
  }
  
  .container-addButton {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--primary-color);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .rulesetIcon{
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: white;
    color: red;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    z-index: 100;
    bottom: 0px;
    left: 5px;
    transform: translateX(-50%);
    border: 1px solid white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  }

  .rulesetIcon:hover{
    border: 1px solid red;
  }
  
  .clickedAddButton {
    background: var(--secondary-color);
  }
  
  .container-addButton.top {
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .container-addButton.bottom {
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .add-list {
    position: absolute;
    z-index: 10;
  }
  
  .delete-button {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
    padding: 5px;
    position: absolute;
    top: -10px;
    left: -10px;
    background: white;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 2;
  }
  
  .component-container:hover .delete-button {
    opacity: 1;
  }

  .elseBlock {
    font-family: 'Montserrat', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f0f0f0;
    height: 60px;
    position: relative;
    cursor: pointer;
    border: 2px dashed #ccc;
    transition: background-color 0.3s;
    }
  </style>
  